<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <!-- ===== MODAL: FORM (criar / editar) ===== -->
    <modal name="integracaoForm" height="auto" width="700" :adaptive="true" :scrollable="true" :clickToClose="false">
      <CloseModal :close="closeForm" />
      <div class="modalbox">
        <div class="modalbox-content">
          <h5 class="tinto-modal__title">{{ form.id ? 'Editar Integração' : 'Nova Integração' }}</h5>
          <div class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="tag" class="mr-1" />Identificação</div>
            <CRow>
              <CCol md="7">
                <div class="form-group"><label class="tinto-label">Descrição</label>
                  <input class="form-control form-control-sm" v-model="form.descricao" placeholder="Nome da integração" />
                </div>
              </CCol>
              <CCol md="5">
                <div class="form-group"><label class="tinto-label">Fabricante</label>
                  <select class="form-control form-control-sm" v-model="form.fabricante_id">
                    <option value="">Selecione</option>
                    <option v-for="(n,id) in fabricantes" :key="id" :value="id">{{ n }}</option>
                  </select>
                </div>
              </CCol>
            </CRow>
          </div>

          <div class="tinto-section">
            <div class="tinto-section__label">
              <fa-icon icon="building" class="mr-1" />Filiais atendidas
              <fa-icon
                icon="info-circle"
                class="tinto-label__info"
                title="Uma integração pode atender várias filiais. Marque todas as filiais que usam esta integração — mesmas credenciais, fabricante e configurações."
              />
            </div>

            <div class="tinto-picker">
              <div class="tinto-picker__bar">
                <div class="tinto-picker__search">
                  <fa-icon icon="search" class="tinto-picker__search-icon" />
                  <input
                    type="text"
                    class="tinto-picker__search-input"
                    v-model="filialBusca"
                    placeholder="Buscar por código ou nome..."
                  />
                  <fa-icon
                    v-if="filialBusca"
                    icon="times"
                    class="tinto-picker__search-clear"
                    @click="filialBusca = ''"
                  />
                </div>
                <div class="tinto-picker__actions">
                  <span class="tinto-picker__count">{{ form.filiais.length }}/{{ totalFiliais }}</span>
                  <button type="button" class="tinto-picker__link" @click="selecionarTodasFiliais">
                    <fa-icon icon="check-square" class="mr-1" />Todas
                  </button>
                  <button
                    type="button"
                    class="tinto-picker__link"
                    :disabled="!form.filiais.length"
                    @click="limparFiliais"
                  >
                    <fa-icon icon="times" class="mr-1" />Limpar
                  </button>
                </div>
              </div>

              <div class="tinto-picker__list">
                <label
                  v-for="f in filiaisFiltradas"
                  :key="f.id"
                  class="tinto-picker__item"
                  :class="{ 'is-active': form.filiais.includes(f.id) }"
                >
                  <input type="checkbox" :value="f.id" v-model="form.filiais" />
                  <span class="tinto-picker__item-id">{{ f.id }}</span>
                  <span class="tinto-picker__item-nome">{{ f.nome }}</span>
                </label>
                <div v-if="!filiaisFiltradas.length" class="tinto-picker__empty">
                  Nenhuma filial encontrada
                </div>
              </div>
            </div>

            <small v-if="!form.filiais.length" class="tinto-hint tinto-hint--warn">
              <fa-icon icon="exclamation-triangle" class="mr-1" />Selecione ao menos uma filial.
            </small>
          </div>

          <div v-if="tipoIntegracao === 'database'" class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="database" class="mr-1" />Conexão Banco de Dados</div>
            <CRow>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Host</label>
                <input class="form-control form-control-sm" v-model="form.database_ip" placeholder="10.1.1.96" /></div></CCol>
              <CCol md="2"><div class="form-group"><label class="tinto-label">Porta</label>
                <input class="form-control form-control-sm" v-model="form.database_port" placeholder="5432" /></div></CCol>
              <CCol md="3"><div class="form-group"><label class="tinto-label">Driver</label>
                <input class="form-control form-control-sm" v-model="form.database_driver" placeholder="firebird" /></div></CCol>
              <CCol md="3"><div class="form-group"><label class="tinto-label">Charset</label>
                <input class="form-control form-control-sm" v-model="form.database_charset" placeholder="UTF-8" /></div></CCol>
            </CRow>
            <CRow>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Banco</label>
                <input class="form-control form-control-sm" v-model="form.database_name" /></div></CCol>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Usuário</label>
                <input
                  class="form-control form-control-sm"
                  v-model="form.database_user"
                  autocomplete="off"
                /></div></CCol>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Senha</label>
                <input
                  class="form-control form-control-sm"
                  type="password"
                  v-model="form.database_password"
                  autocomplete="new-password"
                  :placeholder="form.id ? 'Deixe em branco para manter a senha atual' : ''"
                /></div></CCol>
            </CRow>
          </div>

          <div v-if="tipoIntegracao === 'api_rest'" class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="cloud" class="mr-1" />Conexão API REST</div>
            <div class="form-group">
              <label class="tinto-label">
                URL da API
                <fa-icon
                  icon="info-circle"
                  class="tinto-label__info"
                  title="Não inclua /api no final — os paths são concatenados automaticamente pelo backend."
                />
              </label>
              <input class="form-control form-control-sm" v-model="form.api_url" placeholder="https://integracao.novoselfcolor.suvinil.com.br" />
              <small v-if="apiUrlComApi" class="tinto-hint tinto-hint--warn">
                <fa-icon icon="exclamation-triangle" class="mr-1" />
                A URL termina com <code>/api</code>. Será removido automaticamente ao salvar.
              </small>
            </div>
            <CRow>
              <CCol md="6"><div class="form-group"><label class="tinto-label">Access Key</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="form.api_access_key"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  :placeholder="form.id ? 'Deixe em branco para manter a chave atual' : ''"
                /></div></CCol>
              <CCol md="6"><div class="form-group"><label class="tinto-label">Access Secret</label>
                <input
                  class="form-control form-control-sm"
                  type="password"
                  v-model="form.api_access_secret"
                  autocomplete="new-password"
                  :placeholder="form.id ? 'Deixe em branco para manter o secret atual' : ''"
                /></div></CCol>
            </CRow>
          </div>

          <div class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="cogs" class="mr-1" />Configurações Gerais</div>
            <CRow>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Usar filtro de linha
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Exibe uma etapa para o usuário escolher a linha antes de listar as cores."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.usa_filtro_linha">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Linha obrigatória
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando ativo, a escolha da linha não pode ser pulada. Só se aplica com o filtro de linha ativo."
                    />
                  </label>
                  <select
                    class="form-control form-control-sm"
                    v-model="form.filtro_linha_obrigatorio"
                    :disabled="!form.usa_filtro_linha"
                  >
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Usar filtro de coleção
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Exibe uma etapa para o usuário escolher a coleção (submarca) antes de listar as cores."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.usa_filtro_colecao">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
            </CRow>
            <div class="form-group">
              <label class="tinto-label">
                E-mail para Pedido Liberado
                <fa-icon
                  icon="info-circle"
                  class="tinto-label__info"
                  title="Múltiplos e-mails separados por vírgula. Se vazio, será usado o parâmetro global GERAL_EMAIL_PEDIDO_LIBERADO_TINTOMETRICO."
                />
              </label>
              <textarea
                class="form-control form-control-sm"
                v-model="form.email_pedido_liberado"
                rows="2"
                maxlength="2000"
                placeholder="exemplo1@dominio.com, exemplo2@dominio.com"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="tinto-modal__footer">
        <button class="button" @click="closeForm">Cancelar</button>
        <button class="button button-primary" @click="submitForm">Salvar</button>
      </div>
    </modal>

    <!-- ===== MODAL: SINCRONIZAÇÃO (histórico + testar + sincronizar) ===== -->
    <modal name="integracaoSync" height="auto" width="860" :scrollable="true" :clickToClose="true">
      <CloseModal :close="closeSync" />
      <div class="modalbox">
        <div class="modalbox-content">
          <h5 class="tinto-modal__title">
            <fa-icon icon="sync" class="mr-2" style="color:#667085" />
            Sincronização — {{ currentIntegracao.descricao }}
          </h5>

          <div class="d-flex align-items-center mb-3" style="gap:8px">
            <button class="button button-info" @click="testConnModal" :disabled="testando">
              <fa-icon :icon="testando ? 'spinner' : 'plug'" :spin="testando" class="mr-1" />
              Testar Conexão
            </button>
            <button class="button button-primary" @click="runSync" :disabled="sincronizando || syncEmAndamento">
              <fa-icon :icon="sincronizando ? 'spinner' : 'bolt'" :spin="sincronizando" class="mr-1" />
              Sincronizar Agora
            </button>
          </div>

          <!-- Progresso em tempo real -->
          <div v-if="syncEmAndamento" class="tinto-section" style="margin-bottom:14px">
            <div class="tinto-section__label"><fa-icon icon="spinner" spin class="mr-1" />Sincronização em andamento...</div>
            <div class="tinto-sync-steps">
              <div v-for="step in syncStepNames" :key="step" class="tinto-sync-step">
                <span class="tinto-sync-step__icon">
                  <fa-icon v-if="stepStatus(step) === 'done'" icon="check-circle" style="color:#027a48" />
                  <fa-icon v-else-if="stepStatus(step) === 'error'" icon="exclamation-triangle" style="color:#b42318" />
                  <fa-icon v-else-if="stepStatus(step) === 'running'" icon="spinner" spin style="color:#004576" />
                  <fa-icon v-else icon="circle" style="color:#d0d5dd;font-size:8px" />
                </span>
                <span class="tinto-sync-step__name">{{ step }}</span>
                <template v-if="stepStatus(step) === 'done'">
                  <span class="tinto-sync-step__detail">{{ stepDetail(step) }}</span>
                </template>
                <template v-else-if="stepStatus(step) === 'running' && stepProgress(step)">
                  <span class="tinto-sync-step__progress">
                    <span class="tinto-progress-bar">
                      <span class="tinto-progress-bar__fill" :style="{ width: stepProgress(step).pct + '%' }"></span>
                    </span>
                    <span class="tinto-sync-step__counter">{{ stepProgress(step).processados | number }} / {{ stepProgress(step).total | number }} ({{ stepProgress(step).pct }}%)</span>
                  </span>
                </template>
              </div>
            </div>
          </div>

          <!-- Histórico -->
          <div class="tinto-section">
            <div class="tinto-section__label">Histórico de Sincronizações</div>
            <div v-if="loadingHistorico" class="tinto-table__empty">
              <fa-icon icon="spinner" spin /> Carregando...
            </div>
            <div v-else class="tinto-table-wrap">
              <table class="tinto-table">
                <thead><tr>
                  <th style="width:160px">Início</th>
                  <th style="width:90px;text-align:center">Status</th>
                  <th style="width:90px;text-align:right">Duração</th>
                  <th style="width:90px;text-align:center">Disparado</th>
                  <th>Mensagem</th>
                </tr></thead>
                <tbody>
                  <tr v-if="historico.length === 0">
                    <td colspan="5" class="tinto-table__empty">Nenhuma sincronização registrada</td>
                  </tr>
                  <tr v-for="h in historico" :key="h.id">
                    <td><span class="tinto-table__sub">{{ h.iniciado_em | dt }}</span></td>
                    <td style="text-align:center">
                      <span :class="['tinto-badge', syncStatusClass(h.status)]">{{ h.status }}</span>
                    </td>
                    <td style="text-align:right">
                      <span v-if="h.tempo_execucao_ms" class="tinto-table__sub">{{ formatMs(h.tempo_execucao_ms) }}</span>
                      <span v-else class="tinto-table__muted">—</span>
                    </td>
                    <td style="text-align:center">
                      <span class="tinto-table__sub">{{ h.disparado_por || '—' }}</span>
                    </td>
                    <td><span class="tinto-table__sub">{{ h.mensagem || '—' }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="tinto-modal__footer">
        <button class="button" @click="closeSync">Fechar</button>
      </div>
    </modal>

    <!-- ===== HEADER ===== -->
    <div class="tinto-page__header" style="justify-content: flex-end">
      <button class="button button-primary" @click="openCreate">
        <fa-icon icon="plus" /> Nova
      </button>
    </div>

    <!-- ===== TABLE ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:240px">Descrição</th>
          <th style="width:110px">Fabricante</th>
          <th style="width:200px">Filiais</th>
          <th style="width:150px;text-align:center">Última Sync</th>
          <th style="width:60px;text-align:center">Ativo</th>
          <th style="width:140px"></th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="7" class="tinto-table__empty">Nenhuma integração cadastrada</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td>
              <span class="tinto-table__primary">{{ r.descricao }}</span>
              <span class="tinto-table__sub" v-if="r.databaseIp">{{ r.databaseIp }}:{{ r.databasePort }}</span>
              <span class="tinto-table__sub" v-else-if="r.apiUrl">{{ r.apiUrl }}</span>
            </td>
            <td>{{ r.fabricanteNome }}</td>
            <td>
              <div v-if="(r.filiais || []).length" class="tinto-chips" :title="filiaisNomes(r)">
                <span
                  v-for="id in (r.filiais || []).slice(0, 3)"
                  :key="id"
                  class="tinto-chip"
                >{{ filialLabel(id) }}</span>
                <span
                  v-if="(r.filiais || []).length > 3"
                  class="tinto-chip tinto-chip--more"
                >+{{ r.filiais.length - 3 }}</span>
              </div>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td style="text-align:center">
              <template v-if="r.ultimaSyncEm">
                <span class="tinto-table__primary" style="font-size:12px;font-weight:400">{{ r.ultimaSyncEm | dtDate }}</span>
                <span class="tinto-table__sub">{{ r.ultimaSyncEm | dtTime }}</span>
              </template>
              <span v-else class="tinto-table__muted">Nunca</span>
            </td>
            <td style="text-align:center">
              <span :class="['tinto-dot', r.ativo ? 'tinto-dot--on' : 'tinto-dot--off']"></span>
            </td>
            <td>
              <div class="tinto-actions">
                <button class="button button-primary" @click="edit(r)" title="Editar">
                  <fa-icon icon="pencil-alt" />
                </button>
                <button :class="['button', syncBtnClass(r)]" @click="openSync(r)" title="Sincronização">
                  <fa-icon icon="sync" />
                </button>
                <button class="button button-error" @click="remove(r)" title="Excluir">
                  <fa-icon icon="trash-alt" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import CloseModal from "../../components/CloseModal";
import { get, post, put, del } from '@/helpers/apiRequest';
import _find from 'lodash/find';

const SYNC_STEP_NAMES = ['linhas', 'cores', 'corantes', 'bases', 'formulas', 'embalagens'];
const POLL_INTERVAL_MS = 3000;
const SYNC_START_DELAY_MS = 1500;

const STATUS_MAP = {
  sucesso: 'tinto-badge--success',
  erro:    'tinto-badge--error',
  parcial: 'tinto-badge--warn',
};

function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

function formatNumber(value) {
  return value ? Number(value).toLocaleString('pt-BR') : '0';
}

export default {
  name: "tintometrico-integracao",
  components: { Loading, CloseModal },
  props: ['filiais', 'fabricantes', 'fabricantesDetalhes'],

  filters: {
    dtDate(v) { return v ? new Date(v).toLocaleDateString('pt-BR') : ''; },
    dtTime(v) { return v ? new Date(v).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''; },
    dt: formatDateTime,
    number: formatNumber,
  },

  data() {
    return {
      items: [],
      loading: false,
      form: this.emptyForm(),
      filialBusca: '',

      currentIntegracao: {},
      historico: [],
      loadingHistorico: false,
      testando: false,
      sincronizando: false,
      pollTimer: null,
      syncStepNames: SYNC_STEP_NAMES,
    };
  },

  computed: {
    tipoIntegracao() {
      if (!this.form.fabricante_id || !this.fabricantesDetalhes) return '';
      const fabricante = _find(this.fabricantesDetalhes, { id: Number(this.form.fabricante_id) });
      return fabricante ? fabricante.tipoIntegracao : '';
    },

    syncEmAndamento() {
      return this.historico.some(h => h.status === 'executando');
    },

    execucaoAtiva() {
      return this.historico.find(h => h.status === 'executando') || null;
    },

    apiUrlComApi() {
      const url = (this.form.api_url || '').trim();
      return /\/api\/?$/i.test(url);
    },

    // Lista normalizada de filiais (a prop `filiais` é um map { id: nome }).
    filiaisLista() {
      return Object.entries(this.filiais || {})
        .map(([id, nome]) => ({ id: String(id), nome }))
        .sort((a, b) => Number(a.id) - Number(b.id));
    },

    totalFiliais() {
      return this.filiaisLista.length;
    },

    filiaisFiltradas() {
      const termo = (this.filialBusca || '').trim().toLowerCase();
      if (!termo) return this.filiaisLista;
      return this.filiaisLista.filter(
        f => `${f.id} ${f.nome}`.toLowerCase().includes(termo)
      );
    },
  },

  beforeMount() { this.load(); },
  beforeDestroy() { this.stopPolling(); },

  methods: {
    // ── CRUD ──────────────────────────────────────────

    emptyForm() {
      return {
        id: null,
        descricao: '',
        filiais: [],
        fabricante_id: '',
        database_ip: '',
        database_port: '',
        database_driver: '',
        database_name: '',
        database_charset: '',
        database_user: '',
        database_password: '',
        api_url: '',
        api_access_key: '',
        api_access_secret: '',
        email_pedido_liberado: '',
        usa_filtro_linha: false,
        filtro_linha_obrigatorio: false,
        usa_filtro_colecao: false,
      };
    },

    load() {
      this.loading = true;
      get('/admin/tintometrico/integracao')
        .then(json => { this.items = json.data || json; })
        .finally(() => { this.loading = false; });
    },

    openCreate() {
      this.form = this.emptyForm();
      this.filialBusca = '';
      this.$modal.show('integracaoForm');
    },

    // ── FILIAIS ───────────────────────────────────────

    // "Todas" respeita a busca: adiciona as filiais atualmente filtradas à
    // seleção (união), sem remover as já marcadas que ficaram fora do filtro.
    selecionarTodasFiliais() {
      const ids = new Set(this.form.filiais);
      this.filiaisFiltradas.forEach(f => ids.add(f.id));
      this.form.filiais = Array.from(ids);
    },

    limparFiliais() {
      this.form.filiais = [];
    },

    edit(integracao) {
      this.form = {
        id: integracao.id,
        descricao: integracao.descricao,
        filiais: (integracao.filiais || []).map(String),
        fabricante_id: integracao.fabricanteId,
        database_ip: integracao.databaseIp,
        database_port: integracao.databasePort,
        database_driver: integracao.databaseDriver,
        database_name: integracao.databaseName,
        database_charset: integracao.databaseCharset,
        database_user: integracao.databaseUser,
        database_password: '',
        api_url: integracao.apiUrl,
        api_access_key: '',
        api_access_secret: '',
        email_pedido_liberado: integracao.emailPedidoLiberado || '',
        usa_filtro_linha: !!integracao.usaFiltroLinha,
        filtro_linha_obrigatorio: !!integracao.filtroLinhaObrigatorio,
        usa_filtro_colecao: !!integracao.usaFiltroColecao,
      };
      this.filialBusca = '';
      this.$modal.show('integracaoForm');
    },

    closeForm() {
      this.$modal.hide('integracaoForm');
    },

    submitForm() {
      if (this.form.api_url) {
        this.form.api_url = this.form.api_url.trim().replace(/\/api\/?$/i, '');
      }

      const payload = { ...this.form };

      // Filiais vêm como strings do <select>; o backend valida integer|exists.
      payload.filiais = (this.form.filiais || []).map(Number);

      // Coerência: "Linha obrigatória" só faz sentido quando o filtro de linha está ativo.
      if (!payload.usa_filtro_linha) {
        payload.filtro_linha_obrigatorio = false;
      }

      // Em edição, não envia credenciais vazias para não sobrescrever as já salvas.
      if (payload.id) {
        ['database_password', 'api_access_key', 'api_access_secret'].forEach(key => {
          if (!payload[key]) delete payload[key];
        });
      }

      this.loading = true;
      const request = payload.id
        ? put(`/admin/tintometrico/integracao/${payload.id}`, payload)
        : post('/admin/tintometrico/integracao', payload);

      request
        .then(() => { this.closeForm(); this.load(); })
        .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
        .finally(() => { this.loading = false; });
    },

    remove(integracao) {
      this.$swal({
        title: 'Excluir integração?',
        text: `"${integracao.descricao}" será removida permanentemente.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      }).then(result => {
        if (!result.isConfirmed) return;
        this.loading = true;
        del(`/admin/tintometrico/integracao/${integracao.id}`)
          .then(() => { this.load(); })
          .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
          .finally(() => { this.loading = false; });
      });
    },

    // ── SINCRONIZAÇÃO ────────────────────────────────

    openSync(integracao) {
      this.currentIntegracao = integracao;
      this.historico = [];
      this.$modal.show('integracaoSync');
      this.loadHistorico(integracao.id);
    },

    closeSync() {
      this.stopPolling();
      this.$modal.hide('integracaoSync');
    },

    loadHistorico(integracaoId) {
      this.loadingHistorico = true;
      get(`/admin/tintometrico/integracao/${integracaoId}/sync-historico`)
        .then(json => {
          this.historico = json.data || [];
          this.syncEmAndamento ? this.startPolling() : this.stopPolling();
        })
        .finally(() => { this.loadingHistorico = false; });
    },

    startPolling() {
      this.stopPolling();
      this.pollTimer = setInterval(() => {
        this.loadHistorico(this.currentIntegracao.id);
      }, POLL_INTERVAL_MS);
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    testConnModal() {
      this.testando = true;
      post(`/admin/tintometrico/integracao/${this.currentIntegracao.id}/test-connection`, {})
        .then(() => {
          this.$swal({ title: 'Conexão OK', icon: 'success', confirmButtonText: 'Fechar' });
        })
        .catch(e => {
          this.$swal({ title: 'Falha na Conexão', text: e.message, icon: 'error', confirmButtonText: 'Fechar' });
        })
        .finally(() => { this.testando = false; });
    },

    runSync() {
      this.sincronizando = true;
      post(`/admin/tintometrico/integracao/${this.currentIntegracao.id}/sync`, {})
        .then(() => {
          this.sincronizando = false;
          setTimeout(() => this.loadHistorico(this.currentIntegracao.id), SYNC_START_DELAY_MS);
        })
        .catch(e => {
          this.sincronizando = false;
          this.$swal({ title: 'Erro', text: e.message, icon: 'error' });
        });
    },

    // ── PROGRESSO DAS ETAPAS ─────────────────────────

    stepData(stepName) {
      return this.execucaoAtiva?.etapas?.[stepName] || null;
    },

    stepStatus(stepName) {
      const exec = this.execucaoAtiva;
      if (!exec) return 'pending';

      const data = this.stepData(stepName);

      if (data) {
        return data.erros > 0 ? 'error' : 'done';
      }

      // A próxima etapa a executar é a primeira que não tem dados
      const isNextStep = SYNC_STEP_NAMES.find(s => !exec.etapas?.[s]) === stepName;
      return isNextStep ? 'running' : 'pending';
    },

    stepDetail(stepName) {
      const data = this.stepData(stepName);
      if (!data) return '';

      const parts = [];
      if (data.inseridos) parts.push(`${formatNumber(data.inseridos)} inseridos`);
      if (data.atualizados) parts.push(`${formatNumber(data.atualizados)} atualizados`);
      return parts.join(', ');
    },

    stepProgress(stepName) {
      const data = this.stepData(stepName);
      if (!data?.total || !data?.processados) return null;

      const pct = Math.min(100, Math.round((data.processados / data.total) * 100));
      return { processados: data.processados, total: data.total, pct };
    },

    // ── HELPERS VISUAIS ──────────────────────────────

    filiaisNomes(integracao) {
      return (integracao.filiais || [])
        .map(id => this.filialLabel(id))
        .filter(Boolean)
        .join(', ');
    },

    // Nome da filial pelo id (fallback para o próprio id se o nome não vier no map).
    filialLabel(id) {
      return this.filiais[id] || `Filial ${id}`;
    },

    syncBtnClass(integracao) {
      const lastSync = integracao.ultimaSincronizacao;
      if (lastSync?.id && !lastSync.sucesso) return 'button-error';
      if (lastSync?.sucesso) return 'button-success';
      return 'button-secondary';
    },

    syncStatusClass(status) {
      return STATUS_MAP[status] || 'tinto-badge--muted';
    },

    formatMs(ms) {
      return ms < 1000 ? `${ms}ms` : `${(ms / 1000).toFixed(1)}s`;
    },
  },
};
</script>
